import request from '@/utils/request'

export function login(data) {
  return request({ url: '/admin/auth/login', method: 'post', data })
}

export function getStaffInfo() {
  return request({ url: '/admin/auth/info', method: 'get' })
}

export function getDashboard() {
  return request({ url: '/admin/dashboard', method: 'get' })
}
